// extracted by mini-css-extract-plugin
export var bought = "customers-also-bought-module--bought--93070";
export var boughtContainer = "customers-also-bought-module--boughtContainer--250c9";
export var boughtTitle = "customers-also-bought-module--boughtTitle--54b87";
export var boughtTop = "customers-also-bought-module--boughtTop--0ebb3";
export var boughtWrapper = "customers-also-bought-module--boughtWrapper--ff0dc";
export var productsWrapper = "customers-also-bought-module--productsWrapper--11071";
export var swiperSlide = "customers-also-bought-module--swiperSlide--2e95d";